import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Save, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { COUNTIES } from "@/lib/counties";

const field = "w-full rounded-xl border border-talanta-green/15 bg-talanta-cream px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-talanta-green text-talanta-charcoal font-medium";

export const ProfileEditForm = ({ onDone }) => {
  const { user, updateProfile } = useAuth();
  const [form, setForm] = useState({ name: user.name || "", county: user.county || "", email: user.email || "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async () => {
    setBusy(true);
    try {
      await updateProfile(form);
      toast.success("Profile updated");
      onDone();
    } catch (e) {
      toast.error(e?.response?.data?.detail?.[0]?.msg || e?.response?.data?.detail || "Could not save profile");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="profile-edit-form" className="space-y-3">
      <div>
        <label className="text-xs font-semibold uppercase tracking-wider text-talanta-charcoal/50">Full name</label>
        <input data-testid="profile-name-input" value={form.name} onChange={set("name")} placeholder="Your name" className={`mt-1 ${field}`} />
      </div>
      <div>
        <label className="text-xs font-semibold uppercase tracking-wider text-talanta-charcoal/50">County</label>
        <select data-testid="profile-county-select" value={form.county} onChange={set("county")} className={`mt-1 ${field}`}>
          <option value="">Select county</option>
          {COUNTIES.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>
      <div>
        <label className="text-xs font-semibold uppercase tracking-wider text-talanta-charcoal/50">Email</label>
        <input data-testid="profile-email-input" type="email" value={form.email} onChange={set("email")} placeholder="you@example.com" className={`mt-1 ${field}`} />
      </div>
      <div className="flex gap-2 pt-1">
        <button data-testid="profile-save-btn" onClick={save} disabled={busy} className="flex-1 rounded-xl bg-talanta-green hover:bg-talanta-hover py-2.5 text-white text-sm font-semibold flex items-center justify-center gap-2 disabled:opacity-60">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Save className="h-4 w-4" /> Save</>}
        </button>
        <button data-testid="profile-cancel-btn" onClick={onDone} className="rounded-xl border border-talanta-green/20 px-4 py-2.5 text-sm font-semibold text-talanta-charcoal/60 hover:bg-talanta-cream flex items-center gap-1">
          <X className="h-4 w-4" /> Cancel
        </button>
      </div>
    </div>
  );
};
